var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew224({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.92,
    y: 3.16,
    width: 14.16,
    height: 9.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.2,8.91l-.58,1.77H1.86L3.78,5h.88l1.92,5.64H5.8L5.2,8.91Zm1.85-.57L4.5,6.71a10.08,10.08,0,0,1-.29-1h0c-.09.33-.18.67-.29,1L3.35,8.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.41,5.12A10,10,0,0,1,9,5a3.22,3.22,0,0,1,2.28.7,2.6,2.6,0,0,1,.79,2,3,3,0,0,1-.81,2.19,3.48,3.48,0,0,1-2.49.81,12.09,12.09,0,0,1-1.32-.07Zm.73,5a5,5,0,0,0,.73,0,2.16,2.16,0,0,0,2.4-2.39A2,2,0,0,0,9,5.58a4.27,4.27,0,0,0-.85.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.71,5v5.64H13V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew224);
export default __webpack_public_path__ + "static/media/Symbolpack_New_224.56144582ed90a91773795d764d7d32e8.svg";
export { ForwardRef as ReactComponent };